import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Upload, WifiOff, Pause, Loader2 } from 'lucide-react';
import { cn } from '../../../lib/utils';
import { useUploadQueueContext } from '../context/UploadQueueContext';
import { getUploadMode } from '../../../services/uploadStorage';
/**
 * Get mode display info
 */
function getModeInfo(mode, isUploading) {
    if (isUploading) {
        return {
            icon: _jsx(Loader2, { className: "h-3.5 w-3.5 animate-spin" }),
            label: 'Uploading',
        };
    }
    switch (mode) {
        case 'hold':
            return {
                icon: _jsx(Pause, { className: "h-3.5 w-3.5" }),
                label: 'Held',
            };
        case 'wifi-only':
            return {
                icon: _jsx(WifiOff, { className: "h-3.5 w-3.5" }),
                label: 'WiFi only',
            };
        default:
            return {
                icon: _jsx(Upload, { className: "h-3.5 w-3.5" }),
                label: 'Ready',
            };
    }
}
/**
 * Compact upload indicator bar
 */
export const UploadProgressPanel = () => {
    const { queueItems, isProcessing } = useUploadQueueContext();
    // Count pending (non-completed) uploads
    const pendingItems = queueItems.filter(item => item.status !== 'completed');
    const pendingCount = pendingItems.length;
    const uploadingCount = pendingItems.filter(i => i.status === 'uploading').length;
    // Get current mode
    const mode = getUploadMode();
    const { icon, label } = getModeInfo(mode, uploadingCount > 0);
    // Navigate to my-uploads page
    const handleClick = () => {
        window.history.pushState({}, '', '/my-uploads');
        window.dispatchEvent(new PopStateEvent('popstate', { state: {} }));
    };
    // Don't render if no pending items
    if (pendingCount === 0) {
        return null;
    }
    return (_jsxs("button", { onClick: handleClick, className: cn('fixed bottom-4 left-1/2 -translate-x-1/2 z-[1000]', 'flex items-center gap-2 px-4 py-2', 'bg-card/95 backdrop-blur-sm border rounded-full shadow-lg', 'text-sm font-medium', 'hover:bg-accent transition-colors', 'cursor-pointer'), children: [icon, _jsxs("span", { children: [pendingCount, " pending"] }), _jsx("span", { className: "text-muted-foreground", children: "\u2022" }), _jsx("span", { className: "text-muted-foreground", children: label })] }));
};
export default UploadProgressPanel;
